<template>
    <div class="search-cards-alt container section-holder">
        <div v-if="$store.getters.getSearchStoreData != null && $store.getters.getSearchStoreData != undefined && $store.getters.getSearchStoreData.length>0" class="row justify-content-center">
            <div class="col-10 col-sm-8 col-lg-3 filter-content">
                <!-- filters -->
                <div class="card">
                    
                  <!-- category -->
                  <!-- check if categories are present in store and then display -->
                  <b-form-group v-if="$store.getters.getCategoryStoreData!= undefined && $store.getters.getCategoryStoreData!= null && $store.getters.getCategoryStoreData.length > 0 ">
                      <div class="title">{{$t('searchPage.labels.ChooseCategory')}} ( {{$store.getters.getCategoryStoreData!= undefined && $store.getters.getCategoryStoreData!= null && $store.getters.getCategoryStoreData.length > 0 ? $store.getters.getCategoryStoreData.length :'' }} )</div>
                      <b-form-checkbox-group stacked v-model="categoriesSelected" name="category" :options="showAllCategory == false ? $store.getters.getNCategoryStoreData(moreCategory) : $store.getters.getCategoryStoreData">
                          <div v-if ="!showAllCategory" @click="showCategory()" class="sm"> {{$t('searchPage.labels.ShowMore')}}</div>
                          <div v-else @click="hideCategory()" class="sm"> {{$t('searchPage.labels.ShowLess')}}</div>
                      </b-form-checkbox-group>
                  </b-form-group>

                  <!-- language -->
                  <!-- check if languages are present  and then display -->
                  <b-form-group v-if="instanceName !== 'MAHADEMY' && options != undefined && options != null && options.length >0 ">
                      <div  class="title">{{$t('searchPage.labels.Language')}} ( {{options.length}} )</div>
                      <b-form-checkbox-group stacked v-model="languageSelected" name="lang" :options="showAllLanguage == false ? halfoptions : options">
                          <div v-if ="!showAllLanguage" @click="showLanguage()" class="sm"> {{$t('searchPage.labels.ShowMore')}}</div>
                          <div v-else @click="hideLanguage()" class="sm"> {{$t('searchPage.labels.ShowLess')}}</div>
                      </b-form-checkbox-group>
                  </b-form-group>
                    
                  <!-- cost -->
                  <!-- check if cost is present in store and then display -->
                  <b-form-group v-if ="instanceName !== 'MAHADEMY' && value != undefined && value != null && value.length > 0 && cost != undefined && cost != null && cost.length > 0">
                      <div class="title">{{$t('searchPage.labels.Cost')}}</div>
                      <!-- <vue-slider  class="pb-4"  :min = 0 :max = cost[1] ref="slider" v-model="value" ></vue-slider> -->
                      <vue-slider v-if="checkForRTL()" :reverse=true class="pb-4"  :min = 0 :max = cost[1] ref="slider" v-model="value" ></vue-slider>
                      <vue-slider v-else  class="pb-4"  :min = 0 :max = cost[1] ref="slider" v-model="value" ></vue-slider>
                  </b-form-group>
                    
                  <!-- duration  -->
                  <!-- check if duration is present and then display -->
                  <b-form-group v-if="instanceName !== 'MAHADEMY' && duration!= undefined && duration!= null">
                      <div class="title">{{$t('searchPage.labels.Duration')}}</div>
                      <b-form-radio-group stacked v-model="durationSelected" name="dur" :options="duration">
                      </b-form-radio-group>
                  </b-form-group>
                    
                  <!-- clear all filter -->
                  <div class="title filter" @click="clearFilters()">{{$t('searchPage.labels.ClearAllFilters')}} </div>
                </div>
        
            </div>
            
            <!-- loader Section -->
            <div v-if="showLoader!=undefined && showLoader!=null && showLoader" class="col-lg-9 description align-middle">
              <div  class="total-results" >
                <img src="../../../static/assets/images/eclipse.gif" class="img-fluid" alt=""> <br> {{$t('searchPage.labels.loading')}}
              </div>
            </div>

            <!-- result section -->
            <div v-else class="col-lg-9 description align-middle">
                
                <!-- if result was fetch -->
                <div v-if="$store.getters.getFilteredData({'categorySelected': this.categoriesSelected, 'languageSelected': this.languageSelected, 'duration': this.durationSelected, 'cost': this.value}) !== undefined && $store.getters.getFilteredData({'categorySelected': this.categoriesSelected, 'languageSelected': this.languageSelected, 'duration': this.durationSelected, 'cost': this.value}) !== null && $store.getters.getFilteredData({'categorySelected': this.categoriesSelected, 'languageSelected': this.languageSelected, 'duration': this.durationSelected, 'cost': this.value}).length > 0">       
                  
                  <!-- show no of status -->
                  <span class="total-results" v-if ="instanceName !== 'MAHADEMY' && $store.getters.getFilteredData({'categorySelected': this.categoriesSelected, 'languageSelected': this.languageSelected, 'duration': this.durationSelected, 'cost': this.value}).length < $store.getters.getTotalResultLength">{{$t('searchPage.labels.showing')}} <span>{{$store.getters.getFilteredData({'categorySelected': this.categoriesSelected, 'languageSelected': this.languageSelected, 'duration': this.durationSelected, 'cost': this.value}).length}}</span> {{$t('searchPage.labels.resultsOutOf')}} {{$store.getters.getTotalResultLength}} for <span>{{$store.getters.getSearchText}}</span></span>
                  <span class="total-results" v-else-if ="instanceName !== 'MAHADEMY' && $store.getters.getFilteredData({'categorySelected': this.categoriesSelected, 'languageSelected': this.languageSelected, 'duration': this.durationSelected, 'cost': this.value}).length === $store.getters.getTotalResultLength">{{$t('searchPage.labels.showing')}} <span>{{$store.getters.getFilteredData({'categorySelected': this.categoriesSelected, 'languageSelected': this.languageSelected, 'duration': this.durationSelected, 'cost': this.value}).length}}</span> {{$store.getters.getFilteredData({'categorySelected': this.categoriesSelected, 'languageSelected': this.languageSelected, 'duration': this.durationSelected, 'cost': this.value}).length >1 ? $t('searchPage.labels.multipleResults') : $t('searchPage.labels.singleResults') }}  <span>{{$store.getters.getSearchText}}</span></span>
                  <span class="total-results" v-else-if ="instanceName === 'MAHADEMY' && 
                                                          $store.getters.getFilteredData({'categorySelected': this.categoriesSelected, 'languageSelected': this.languageSelected, 'duration': this.durationSelected, 'cost': this.value}).length === $store.getters.getTotalResultLength">
                                                          {{$store.getters.getSearchText}} {{$t('searchPage.labels.showing')}} <span>{{$store.getters.getFilteredData({'categorySelected': this.categoriesSelected, 'languageSelected': this.languageSelected, 'duration': this.durationSelected, 'cost': this.value}).length}}</span>   {{$t('searchPage.labels.multipleResults')}}</span>
                  
                  <!-- display result  -->
                  <div class="card-design card-design-h" v-for="(tmp,i) in this.$store.getters.getFilteredData({'categorySelected': this.categoriesSelected, 'languageSelected': this.languageSelected, 'duration': this.durationSelected, 'cost': this.value})" :key="i">
                    <!-- checks whether CDP path is present -->
                    <div v-if="tmp.thumbnail.length != 0" class="card-design__img">
                      <img :src="makePath(tmp.thumbnail)" alt="">
                    </div>

                    <!-- Add defaultLO if no CDP path is found and type LO  -->
                    <div v-else-if="tmp.type=='LO'" class="card-design__img">
                      <img src="../../../static/assets/images/defaultLO.jpg" alt="">
                    </div>

                    <!-- Add defaultCO if no CDP path is found and type CO  -->
                    <div v-else class="card-design__img">
                      <img src="../../../static/assets/images/defaultCO.jpg" alt="">
                    </div>
                    
                    <div class="card-design__data">
                      <!-- text based info -->
                      <router-link v-if ="tmp.type =='CO' && instanceName !== 'MAHADEMY'" class="card-design__data-heading" :to="{ name: 'coursePage', params: { contentId: tmp.contentId }}">{{tmp.title}}</router-link>
                      <h3 v-if="tmp.type =='CO' && instanceName === 'MAHADEMY'" class="card-design__data-heading no-line" >{{tmp.title}}</h3>
                      <h3 v-if="tmp.type =='LO'" class="card-design__data-heading no-line" >{{tmp.title}}</h3>
                      
                      <p class="card-design__data-cost" v-if="instanceName !== 'MAHADEMY'">{{tmp.price}} {{tmp.price >1 ? 'Points' : 'Point'}}</p>

                      <div class="row card-design__details">
                        
                        <!--rating section  -->
                        <span class="col-auto card-design__data-ratings">                         
                          <span v-if="tmp.rating == 0 && instanceName !== 'MAHADEMY'">                             
                            <div class="ratingText">{{$t('common.labels.OVERALL_RATING')}}</div>
                            <star-rating :rating="parseInt(tmp.rating)" :read-only=true v-bind:increment="0.5" v-bind:max-rating="5" inactive-color="#96999a" active-color="#ffc000" v-bind:star-size="15">
                            </star-rating>    
                          </span>
                          <span v-else-if="instanceName !== 'MAHADEMY'">
                             <div class="ratingText">{{$t('common.labels.OVERALL_RATING')}}</div>
                            <star-rating :rating="parseInt(tmp.rating.toFixed(1))" :read-only=true v-bind:increment="0.5" v-bind:max-rating="5" inactive-color="#96999a" active-color="#ffc000" v-bind:star-size="15">
                            </star-rating>  
                          </span>
                        </span>
                       
                        <!-- enrollment count -->
                        <!-- <div class="col-auto">
                          <span>{{$t('searchPage.labels.EnrolledCount')}}</span>
                          <strong>{{tmp.enrolledCount}} +</strong>
                        </div> -->

                        <!-- if LO then show duration -->
                        <span class="col-auto" v-if="tmp.type == 'LO' && tmp.duration !== 0">
                          <div> {{$t('searchPage.labels.Duration')}}</div><strong>{{parseInt(tmp.duration / 60)}} min {{parseInt((tmp.duration / 60).toFixed(1).split('.')[1])*6 == 0 ? "" : parseInt((tmp.duration / 60).toFixed(1).split('.')[1])*6}} {{parseInt((tmp.duration / 60).toFixed(1).split('.')[1])*6 === 0 ? "" : "sec"}}</strong>
                          <!-- <strong>{{parseInt(tmp.duration / 60)}} min {{parseInt((tmp.duration / 60).toFixed(1).split('.')[1])*6 == 0 ? "" : parseInt((tmp.duration / 60).toFixed(1).split('.')[1])*6}} {{checkSec(parseInt((tmp.duration / 60).toFixed(1).split('.')[1])*6)}}</strong> -->
                        </span>
                        <!-- if CO then show no of Lectures -->
                        <span class="col-auto" v-if="tmp.type=='CO'">
                          <div>{{$t('searchPage.labels.Lectures')}}</div><strong>{{tmp.totalNumberofLO}}</strong>
                        </span>
                      <!-- languages of content -->
                        <span class="col-auto" v-if ="tmp.languageId != undefined && displayLanguage(tmp.languageId)!= undefined && displayLanguage(tmp.languageId) != null" >
                          <div >{{$t('searchPage.labels.Language')}}</div><strong>{{displayLanguage(tmp.languageId)}}</strong>
                          
                        </span>
                        
                         <!-- share widgets only for CO-->
                        <span class="col-auto" v-if="tmp.type !== null && tmp.type !== undefined && tmp.type ==='CO'">
                           Share via
                           <share-on-media :item="tmp" :labelOnTop="false"></share-on-media>                          
                        </span>
                        <!-- Tags -->
                        <span class="col-auto">
                           Tags
                           <div><strong>{{getTagString(tmp)}}</strong></div>                          
                        </span>
                         
                      </div>
                      <!-- action to perform if user is logged in -->
                      <div v-if="isLoggedIn" class="row box-action">
                        <!-- cart / content viewer section -->
                        <!-- if user had purchased item -->
                        <div v-if="$store.getters.getItemSubscriptionStatus({'id': tmp.contentId, 'type': tmp.type}) != undefined &&
                                   $store.getters.getItemSubscriptionStatus({'id': tmp.contentId, 'type': tmp.type}) != null && 
                                   $store.getters.getItemSubscriptionStatus({'id': tmp.contentId, 'type': tmp.type}) 
                                   ||
                                   $store.getters.getTagAllocationStatus({'contentTagList' : tmp.tagList}) != undefined &&
                                   $store.getters.getTagAllocationStatus({'contentTagList' : tmp.tagList}) != null &&
                                   $store.getters.getTagAllocationStatus({'contentTagList' : tmp.tagList})" 
                        class="col">
                          <!-- if item is CO -->
                          <button class='btn btn-green-o' @click="playLO(tmp)" v-if="tmp.type =='CO'">{{$t('common.labels.GO_TO_COURSE')}}</button>
                          <!-- if item is LO -->
                          <button class='btn btn-green-o' @click="playLO(tmp)" v-else>{{$t('common.labels.PLAY_NOW')}}</button>
                        </div>
                        <!-- if item is added to cart -->
                        <div v-else-if="featureStatusInfoList.cart && $store.getters.itemPresentInCartStatus(tmp.contentId)!= undefined && $store.getters.itemPresentInCartStatus(tmp.contentId)!= null && $store.getters.itemPresentInCartStatus(tmp.contentId)" class="col">
                          <button class='btn btn-green-o'>{{$t('common.labels.ADDED')}}</button>
                        </div>
                        <!-- if item not in cart and not purchased -->
                        <div v-else-if="featureStatusInfoList.cart" class="col">
                          <button @click="addToCart(tmp.contentId)" class='btn btn-green-o'>{{$t('common.labels.ADD_TO_CART')}}</button>
                        </div>
                       
                       <!-- wishList section -->
                        <!-- if user had not purchased item -->
                        <div v-if="featureStatusInfoList.wishlist && $store.getters.getItemPurchasedStatus(tmp.contentId) != undefined && $store.getters.getItemPurchasedStatus(tmp.contentId) != null && !$store.getters.getItemPurchasedStatus(tmp.contentId)" class="col-auto heart-holder">
                          <!-- if item is already in wishList -->
                          <div v-if="$store.getters.itemPresentInWishListStatus(tmp.contentId) != undefined && $store.getters.itemPresentInWishListStatus(tmp.contentId) != null && $store.getters.itemPresentInWishListStatus(tmp.contentId)">                                  
                            <div class="heart"  v-show="$store.getters.itemPresentInCartStatus(tmp.contentId) != undefined && $store.getters.itemPresentInCartStatus(tmp.contentId)!= null && !$store.getters.itemPresentInCartStatus(tmp.contentId)"  v-on:click="removeFromWishList(tmp.contentId)" title="Add to Wishlist" v-bind:class="{ 'is-active' : true}"></div>
                          </div>
                          <!-- if item added to cart -->
                          <div v-else-if="$store.getters.itemPresentInCartStatus(tmp.contentId) != undefined && $store.getters.itemPresentInCartStatus(tmp.contentId)!= null && $store.getters.itemPresentInCartStatus(tmp.contentId)"></div>
                          <!-- if item not in wishList and not purchased-->
                          <div v-else>
                            <div class="heart" v-on:click="addToWishList(tmp.contentId)" title="Add to Wishlist" v-bind:class="{ 'is-active' : false}"></div>
                          </div>
                        </div>
                      </div>

                      <div v-else class="row box-action">
                        <div class="col" v-if="featureStatusInfoList.cart">
                          <button @click="goToLogin()" class='btn btn-green-o'>{{$t('common.labels.ADD_TO_CART')}}</button>
                        </div>
                        <div class="col-auto heart-holder" v-if="featureStatusInfoList.wishlist">
                          <div class="heart" @click="goToLogin()"></div>
                        </div>
                      </div>
                    </div>
                  </div>



                  <!-- loader -->
                  <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="infiniteLoader">
                    <span slot ='no-results'>{{$t('searchPage.labels.allResultsDisplayed')}}</span>
                    <span slot ='no-more'>{{$t('searchPage.labels.allResultsDisplayed')}}</span>
                  </infinite-loading>
                </div>

                <!-- no result section when filter doesn't match-->
                <div  v-else>
                    <div class="noticemsg">
                        <span> {{$t('searchPage.labels.noRecordsFound')}}</span>
                    </div>
                </div>
            </div>

        </div>

        <!-- no result section when no search result was fectch -->
        <div v-else>
          <div class="noticemsg">
            <span v-if="$store.getters.getSearchText.length > 0"> {{$t('searchPage.labels.noRecordsFound')}}</span>
            <span v-else>{{$t('searchPage.labels.EnterTextToSearch')}}</span>
          </div>
        </div>
    </div>
</template>
<script>
import {CDP_CDN_THUMBNAIL_URL, INSTANCE_NAME} from '@/components/common/constants.js'
import InfiniteLoading from 'vue-infinite-loading'
import { EventBus } from '@/main.js'
import StarRating from 'vue-star-rating'
import vueSlider from 'vue-slider-component'
import axios from 'axios'
import ShareOnMedia from '../common/shareOnMedia'
export default {
  name: 'searchCards',
  components: {
    vueSlider,
    StarRating,
    InfiniteLoading,
    ShareOnMedia
  },
  data () {
    return {
      // multipleResults: $t('searchPage.labels.multipleResults'),
      // singleResults: $t('searchPage.labels.singleResults'),
      instanceName: INSTANCE_NAME,
      userId: '',
      showLoader: true,
      moreCategory: '',
      showAllCategory: false,
      showAllLanguage: false,
      value: [],
      cost: [],
      tooltip: 'always',
      formatter: 'Rs {value}',
      dtoggle: false,
      ctoggle: false,
      etoggle: false,
      rtoggle: false,
      languageSelected: [],
      categoriesSelected: [],
      durationSelected: {},
      halfoptions: [{ text: 'English', value: '1' }, { text: 'हिन्दी', value: '2' }],
      options: [{ text: 'English', value: '1' }, { text: 'हिन्दी', value: '2' }, { text: 'मराठी', value: '3' }],
      categories: [],
      duration: {'low': { text: 'Low to High', value: 0 }, 'high': { text: 'High to Low', value: 1 }},
      searchResult: [],
      searchClickStatus: false,
      Language: ''
    }
  },
  methods: {
    // checks whether rtl style is followed
    checkForRTL () {
      if (document.getElementsByTagName('body')[0].getAttribute('dir') !== undefined && document.getElementsByTagName('body')[0].getAttribute('dir') === 'rtl') {
        return true
      }
      return false
    },
    // makes URL for CDP path
    makePath (path) {
      return CDP_CDN_THUMBNAIL_URL + '/' + path
      // return 'http://10.2.10.230:3035/cdpcdn/thumnail/' + path
    },
    //  handles lazy loading
    infiniteHandler ($state) {
      if (this.$store.getters.getFilteredData({'categorySelected': this.categoriesSelected, 'languageSelected': this.languageSelected, 'duration': this.durationSelected, 'cost': this.value}).length > 0) {
        // console.log(this.$store.getters.getFirstIndex + '<' + this.$store.getters.getTotalResultLength)
        // console.log(this.$store.getters.getTotalResultLength + '>' + this.$store.getters.getLastIndex)
        // if (this.$store.getters.getTotalResultLength > this.$store.getters.getLastIndex) {
        // console.log((this.$store.getters.getFirstIndex + '<' + this.$store.getters.getTotalResultLength))
        // console.log((this.$store.getters.getTotalResultLength + '<' + this.$store.getters.getLastIndex))
        if ((this.$store.getters.getFirstIndex < this.$store.getters.getTotalResultLength) && (this.$store.getters.getTotalResultLength > this.$store.getters.getLastIndex)) {
          if (this.isLoggedIn) {
            var profileDetails = this.$store.getters.getProfileDetails
            if (profileDetails !== null && profileDetails.profileId != null) {
              this.userId = profileDetails.profileId
            }
          }
          // old working
          // this.$store.dispatch('appendSearchResult', {'searchText': this.$store.getters.getSearchText, 'userId': this.userId, 'startIndex': this.$store.getters.getLastIndex + 1, 'lastIndex': this.$store.getters.getLastIndex + 6}).then(response => {
          this.$store.dispatch('appendSearchResult', {'searchText': this.$store.getters.getSearchText, 'userId': this.userId, 'startIndex': this.$store.getters.getLastIndex, 'lastIndex': this.$store.getters.getLastIndex + 5, 'location': {'coordinates': [0.0, 0.0]}}).then(response => {
            // to be called to finish current scroll event
            $state.loaded()
          }, error => {
            console.log('error in apending search result', error)
          })
        } else {
          // to be called when complete result displayed
          $state.complete()
        }
      }
    },
    displayLanguage (langArr) {
      // alert(JSON.stringify(langArr))
      // console.log(JSON.stringify(langArr))
      var language = ''
      for (let i = 0; i < langArr.length; i++) {
        // alert(langArr[i])
        if (langArr[i] === '1') {
          if (language.length !== 0) {
            language = language + ', English'
          } else {
            language = 'English'
          }
        } else if (langArr[i] === '2') {
          if (language.length !== 0) {
            language = language + ', Hindi'
          } else {
            language = 'Hindi'
          }
        } else if (langArr[i] === '3') {
          if (language.length !== 0) {
            language = language + ', Marathi'
          } else {
            language = 'Marathi'
          }
        }
      }
      return language
    },
    getTagString (contentObj) {
      var tagsArray = []
      if (contentObj.metadata.courseObj.Tags !== null && contentObj.metadata.courseObj.Tags !== undefined && contentObj.learningObjectTags !== null && contentObj.learningObjectTags !== undefined) {
        if (contentObj.metadata.courseObj.Tags.length > 0 && contentObj.learningObjectTags.length > 0) {
          tagsArray = contentObj.metadata.courseObj.Tags.concat(contentObj.learningObjectTags)
        } else if (contentObj.metadata.courseObj.Tags.length > 0 && contentObj.learningObjectTags.length === 0) {
          tagsArray = contentObj.metadata.courseObj.Tags
        } else if (contentObj.metadata.courseObj.Tags.length === 0 && contentObj.learningObjectTags.length > 0) {
          tagsArray = contentObj.learningObjectTags
        }
      }
      return tagsArray.join(', ')
    },
    showLanguage () {
      this.showAllLanguage = true
    },
    hideLanguage () {
      this.showAllLanguage = false
    },
    showCategory () {
      this.showAllCategory = true
    },
    hideCategory () {
      this.showAllCategory = false
    },
    goToLogin () {
      this.$root.$emit('bv::show::modal', 'login')
    },
    // insert item in wishList
    addToWishList (itemId) {
      // if user is loggedIn then call to insert api
      if (this.isLoggedIn) {
        this.$store.dispatch('insertWishListInDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: itemId }).then(
          response => {
            this.$toasted.success(this.$t('searchPage.alerts.AddItemToWishlist'))
          },
          error => {
            console.error('error in adding item to wishList', error)
          }
        )
      } else {
        window.MKCLAPI.login()
      }
    },
    // remove item from wishList
    removeFromWishList (itemId) {
      this.$swal({
        title: 'Are you sure, you want to remove item from WishList ?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          this.$store.dispatch('removeWishListFromDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: itemId }).then(
            response => {
              this.$toasted.success(this.$t('wishlist.alerts.RemoveItem'))
            },
            error => {
              console.log('error in removing item from db', error)
            }
          )
        }
      })
      // this.$store.dispatch('removeWishListFromDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId }).then(
      //   response => {
      //     this.$toasted.success(this.$t('searchPage.alerts.ItemRemovedFromWishlist'))
      //   },
      //   error => {
      //     console.error('error in removing item from wishList', error)
      //   }
      // )
    },
    // checks whether is item is added in wishList
    presentInWishListStore (itemId) {
      if (this.$store.getters.getWishListStoreData !== undefined && this.$store.getters.getWishListStoreData !== null) {
        for (var i = 0; i < this.$store.getters.getWishListStoreData.length; i++) {
          if (this.$store.getters.getWishListStoreData[i].itemId === itemId) {
            return true
          }
        }
      }
      return false
    },
    // clears all filters applied by user
    clearFilters () {
      // reset all values
      this.languageSelected = []
      this.categoriesSelected = []
      this.durationSelected = {}
      this.value = this.$store.getters.getSearchPrice
      this.cost = this.$store.getters.getSearchPrice
    },
    addToCart (id) {
      if (this.isLoggedIn) {
        // if (!this.presentInWishListStore(id)) {
        //   this.addToWishList(id)
        // }
        // if user is loggedIn then call to insert api
        this.$store.dispatch('addCartData', { itemId: id, profileId: this.$store.getters.getProfileDetails.profileId, cartId: this.$store.getters.getCartData.cartId }).then(
          response => {
            this.$toasted.success(this.$t('searchPage.alerts.AddItemToCart'))
          },
          error => {
            this.$toasted.error(this.$t('searchPage.alerts.CartAddError'))
            console.log(error)
          }
        )
      } else {
        window.MKCLAPI.login()
      }
    },
    playLO (val) {
      var playlist = []
      // alert(val.type)
      // console.log(JSON.stringify(val))
      if (val.type === 'CO') {
        // redirect to era
        this.$store.dispatch('checkExpiryDateForCO', val)
      } else {
        playlist.push(val)
        this.$store.dispatch('setCurrentContentViewerPlaylist', playlist)
        this.$store.dispatch('setIsPlaylist', false)
        this.$router.push('/frames')
      }
    },
    viewCourse (course) {
      if (course.type === 'CO') {
        if (this.isLoggedIn) {
          var tokenString = window.MKCLAPI.getToken()
          axios.post('r/viewEnrolledItem', { profileId: this.$store.getters.getProfileDetails.profileId, contentId: course.contentId }, { headers: { Authorization: tokenString } }).then(response => {
            this.$store.dispatch('setCurrentCourse', response.data)
            this.$store.dispatch('getCourseDetails', course.contentId)
          })
        } else {
          this.$store.dispatch('setCurrentCourse', course)
          this.$store.dispatch('getCourseDetails', course.contentId)
        }
        this.$router.push({ path: '/coursePage' })
      }
    }
  },
  beforeDestroy () {
    // clear all store result and other details
    this.$store.dispatch('removePreviousSearchResult').then(response => {
    }, error => {
      console.log('error in clearing search store data from SEARCHCARDALT', error)
    })
  },
  mounted () {
    // sets TimeOut for loader
    setTimeout(() => {
      this.showLoader = false
    }, 1000)
    // fetched value for filter section
    this.cost = this.$store.getters.getSearchPrice
    this.value = this.$store.getters.getSearchPrice
    this.moreCategory = Math.floor(this.$store.getters.getCategoryStoreData.length / 2)
  },
  created () {
    this.loList = this.$store.getters.getCourseEnrolled
    // listens to searchEvent when user search new item
    EventBus.$on('searchEvent', () => {
      // this.showLoader = true
      // setTimeout(() => {
      //   this.showLoader = false
      // }, 1000)
      // clears previous filters
      this.clearFilters()
      // resets previous scroll
      if (this.$refs.infiniteLoader !== undefined) {
        this.$refs.infiniteLoader.$emit('$InfiniteLoading:reset')
      }
      // resets index
      this.$store.dispatch('setIndexesOnSearch').then({
      }, error => {
        console.log('error in setting index to (0,5)', error)
      })
    })
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.getIsLoggedIn
    }
  }
}
</script>

<style lang="scss">
@import '../../../static/assets/styles/scss/variables.scss';
.search-cards-alt {
  .heart {
        z-index: 5;
        position: absolute;
        top: -44px;
        right: -30px;
        width: 100px;
        height: 100px;
        background: url('../../../static/assets/images/heart2.png') no-repeat;
        background-position: 0 0;
        cursor: pointer;
        transition: background-position 1s steps(28);
        transition-duration: 0s;
        &.is-active {
        transition-duration: 1s;
        background-position: -2800px 0;
        }
    }
  .collapsing {
    transition: none;
    -webkit-transition: none;
    display: none;
    animation: fade;
  }
  .filter-content {
    .title {
      font-weight: 700;
      font-family: $opensans;
      color: #666;
      font-size: 14px;
      line-height: 25px;
      text-transform: uppercase;
      padding-bottom: 10px;
    }
    .sm {
      padding-top: 5px;
      font-size: 13px;
      color: #3fa8e0;
      &:hover {
        text-decoration: underline;
      }
    }
    /*.custom-controls-stacked {
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
    }*/
    .vue-slider-component {
      margin-top: 35px;
    }
    .custom-control-description {
      margin-right: 10px;
      // font-weight: 400;
      color: #555;
      font-family: $montserrat;
      font-size: 13px;
    }
    .custom-control-indicator {
      position: absolute;
      top: 0.25rem;
      left: 0;
      display: block;
      width: 1rem;
      height: 1rem;
      background-color: #ddd;
      border: none;
      box-shadow: none;
    }
    .custom-control-input:checked ~ .custom-control-description {
      color: #333;
    }
    .custom-control-input:checked ~ .custom-control-indicator {
      color: #fff;
      background-color: #333;
    }
    .filter {
      color: #333;
      &:hover {
        color: rgb(230, 72, 72);
      }
    }
  }
  .card {
    border-radius: 3px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.18);
    border: none;
    background-color: #fff;
    transition: box-shadow 0.25s;
    margin-bottom: 35px;
    padding: 25px;
    /*cursor: default !important;*/
    .description {
      font-family: $montserrat;
      h5 {
        font-weight: 700;
        color: #333;
        font-size: 16px;
        line-height: 25px;
        font-family: $opensans;
      }
      p {
        color: #555;
        font-size: 12px;
      }
      .details-css {
        padding-right: 10px;
        font-size: 12px;
        margin-bottom: 5px;
        display: inline-block;
        span {
          color: #555;
          font-size: 12px;
        }
        strong {
          color: #333;
          font-size: 12px;
          padding-left: 8px;
          font-weight:700;
        }
      }
      .mr {
        margin-left: -5px;
      }
    }
    &:hover {
      cursor: pointer;
      transition: box-shadow 0.45s;
      box-shadow: 0px 10px 45px rgba(0, 0, 0, 0.25);
      .play-icon {
        .fa {
          color: rgba(255, 255, 255, 0.9);
        }
      }
    }
  }
  .action-btn {
    padding-top: 15px;
  }
}
.total-results {padding-bottom: 20px; display: block; font-family: $montserrat; text-align: center; color: #888;
  span {font-weight: 600; color: #333;}
}
.search-alt {padding: 0;}

.search-cards-alt .filter-content {font-size: 12px; line-height: 22px; color: #656565;
  .card {padding: 0; overflow: hidden; box-shadow: none;}
  .title {font-weight: 600; color: #333; transition: all 0.2s ease-out;
    &.filter {padding: 10px 10px; font-size: 13px; line-height: 20px; text-align: center; color: #999; cursor: pointer;
      &:hover, &:focus {color: #444;/* background: #f8f8f8;*/}
    }
  }
  .form-group {margin-bottom: 0; padding: 20px 25px 20px; border-bottom: 1px solid #eee;}
  .vue-slider-component .vue-slider-tooltip {border-radius: 3px; font-size: 12px; font-weight: 500;}
  /*.vue-slider-component .vue-slider-process {background: linear-gradient(to right, #61bfee 0%, #af96fa 100%);}*/
  .sm {margin-top: 10px; padding-top: 0; font-size: 11px; line-height: 18px;}
}

.card-design.card-design-h {position: relative; max-width: none; display: flex; flex-direction: row; align-items: center;
  .card-design {
    &__img {width: 200px; height: 200px;
      img {max-width: none; max-height: 100%;}
    }
    &__data {padding-left: 30px; padding-right: 30px;}
    &__data-heading {margin-bottom: 15px; height: auto;}
    &__details {font-size: 12px; line-height: 24px; color: #888; font-family: $montserrat;
      strong {font-weight: 600; color: #333;}
    }
  }

  .box-action {max-width: 260px;}
  .heart-holder .heart {top: -35px; right:-20px;}
}

@media (max-width:320px){
  .search-cards-alt{
  .card-design.card-design-h {
  // .heart-holder .heart {
  //   top: -197px;
  //   right: -40px;
  // }
  .card-design {
    &__img {display:none;
      img {display:none;}
    }
  }
  }
}}
@media (min-width:321px) and (max-width:500px){
  .search-cards-alt{
  .card-design.card-design-h {
  // .heart-holder .heart {top: -198px; 
  // right:-83px;
  // }
  }
   .card-design {
    &__img {display:none;
      img {display:none;}
    }
  }
}}
@media (min-width: 992px) {
.search-cards-alt .filter-content {
  .form-group {padding-left: 16px; padding-right: 16px;}
}
}
@media (min-width:500px) and (max-width:769px){
  .search-cards-alt{
  .card-design.card-design-h {
  .card-design {
    &__img {display: none;
      img {display:none;}
    //  &__img {width: 120px; height: 220px;
    //   img {max-width: none; max-height: 100%;}
    }
  }
  }
}}
@media (min-width:770px) and (max-width:1280px){
  .search-cards-alt{
  .card-design.card-design-h {
  .card-design {
     &__img {width: 150px; 
      img {max-width: none; max-height: 100%;}
    }
  }
  }
}}
@media (min-width: 1200px) {
.search-cards-alt .filter-content {
  .form-group {padding-left: 25px; padding-right: 25px;}
}
}

</style>



// WEBPACK FOOTER //
// src/components/searchPage/searchCardsAlt.vue?249471ae